import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { IArchiveButtonHOCProps } from './types';
import { onClick } from './events/onClick';
import { IOpenInDriveButtonEvents, IOpenInDriveButtonFields } from '../../components/OpenInDriveButton/types';
import { OpenInDriveButton } from '../../components/OpenInDriveButton/OpenInDriveButton';
import { onGetLink } from './events/onGetLink';
import { getBoard } from 'app/store/model/selectors/getBoardById';
import {
    isMicrosoftPersonalAccount
} from '../../../../../../../store/model/authUser/selectors/isMicrosoftPersonalAccount';
import { getAuthUserPlatformType } from '../../../../../../../store/model/authUser/selectors/getAuthUserPlatformType';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { EAuthUserPlatformType } from '../../../../../../../types/rest/IRestAuthUser';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IArchiveButtonHOCProps,
): IOpenInDriveButtonFields => {
    const board = getBoard(state, boardId);
    return {
        isMSPersonalAccount: getAuthUser(state).platformType === EAuthUserPlatformType.MICROSOFT && isMicrosoftPersonalAccount(state),
        parentFolderInfo: board.parentFolderInfo,
        platformType: getAuthUserPlatformType(state),
    };
};
const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IArchiveButtonHOCProps
): IOpenInDriveButtonEvents => ({
    onClick: () => dispatch(onClick()),
    onGetLink: () => dispatch(onGetLink(boardId))
});

export const OpenInDriveButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(OpenInDriveButton);

OpenInDriveButtonHOC.displayName = 'OpenInDriveButtonHOC';
